export { default, getServerSideProps } from "../myalbums/index";